import { AdaptError } from "@common/lib/error-handler/adapt-error";

export class ChatResponseAbortedError extends AdaptError {
    public constructor(message: string) {
        super(message);
        this.name = "ChatResponseAbortedError";
    }
}
